module.exports = __webpack_public_path__ + "work.jpg?f54e9141a068f6a15a06fb528a043f89";